const mediaItems = [
  {
    title: '亲亲漫画平台使用指南',
    desc: '3分钟快速上手，了解下拉式阅读的正确打开方式',
    img: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20showing%20comic%20reading%20tutorial%20with%20smartphone%20displaying%20webtoon%2C%20warm%20lighting%2C%20modern%20clean%20setting%2C%20cream%20background%2C%20editorial%20photography&width=800&height=450&seq=media-guide-01&orientation=landscape',
    icon: 'ri-play-circle-line',
    tag: '教程',
  },
  {
    title: '韩漫热门作品推荐合辑',
    desc: '编辑精选10部必看韩漫，宫廷恋爱与都市悬疑一网打尽',
    img: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20Korean%20manhwa%20recommendation%20collection%20with%20colorful%20cover%20art%20collage%2C%20warm%20lighting%2C%20cream%20background%2C%20editorial%20composition&width=800&height=450&seq=media-kr-02&orientation=landscape',
    icon: 'ri-play-circle-line',
    tag: '推荐',
  },
  {
    title: '国漫玄幻巅峰之作盘点',
    desc: '从绝世武魂到完美世界，领略国产漫画的崛起之路',
    img: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20Chinese%20manhua%20fantasy%20showcase%20with%20epic%20martial%20arts%20illustration%20collage%2C%20warm%20earth%20tones%2C%20cream%20background%2C%20editorial%20composition&width=800&height=450&seq=media-cn-03&orientation=landscape',
    icon: 'ri-play-circle-line',
    tag: '盘点',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              <i className="ri-vidicon-line text-sm"></i>
              精彩内容
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-3">
              精彩展示
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              通过图文并茂的展示，深入了解亲亲漫画的精彩世界
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {mediaItems.map((item, i) => (
              <a
                key={i}
                href="#media"
                className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
              >
                <div className="aspect-[16/9] overflow-hidden bg-background-100 relative">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                      <i className={`${item.icon} text-2xl`}></i>
                    </div>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <span className="inline-block text-[10px] font-semibold text-secondary-600 bg-secondary-100 px-2 py-0.5 rounded-full mb-2.5">
                    {item.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}